import { Component } from '@angular/core';

@Component({
  selector: 'app-left-navigational-panel',
  templateUrl: './left-navigational-panel.component.html',
  styleUrl: './left-navigational-panel.component.less'
})
export class LeftNavigationalPanelComponent {

}
